import Alpine from 'alpinejs';
import Collapse from '@alpinejs/collapse';
import { registerProductGallery } from './product-gallery';
import { registerCartStore } from './cart-store';
import { registerSelectMenu } from './select-menu';
import { registerThemePreview } from './theme-preview';
import { registerPhotoReorder } from './photo-reorder';
import { initMotion } from './motion';
import { initEliteMotion } from './branches/elite-motion';
import { initErrorReporting } from './error-reporting';
import * as scrollLock from './scroll-lock';

// Blade drawers reach the lock through this. One implementation for the filter
// drawer, the cart, quick view, the contact panel and the gallery lightbox, so
// they cannot drift apart again.
window.scrollLock = scrollLock;

// First, so anything that breaks below is still captured.
initErrorReporting();

Alpine.plugin(Collapse);
registerProductGallery(Alpine);
// Registered before start() so the drawer can push state into it on init.
registerCartStore(Alpine);
registerSelectMenu(Alpine);
registerThemePreview(Alpine);
registerPhotoReorder(Alpine);
window.Alpine = Alpine;
Alpine.start();

// Scroll motion layer (self-gated on prefers-reduced-motion inside initMotion).
//
// The Elite layer runs after it and every effect no-ops when its markup is
// absent, so Basic pays one querySelectorAll per effect and nothing else. It is
// in the shared bundle for the same reason the branch stylesheet is: a second
// Vite entry point and a per-branch <script> cost more than these few KB.
const startMotion = () => {
    initMotion();
    initEliteMotion();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startMotion);
} else {
    startMotion();
}
